import { useState } from "react";
// import About1 from "../Assests/about-us-image-1.jpg"
// import About2 from "../Assests/about-us-image-2.jpg"


import About1 from "../Assests/HomePageSection2/IMG_20251114_095914321_HDR (1).jpg"
import About2 from "../Assests/HomePageSection2/SDS_0403.JPG"



// Placeholder image URLs (replace with real images)
const IMG_CLASSROOM = About1;
const IMG_GIRL = About2;
const AVATAR1 = "https://static.vecteezy.com/system/resources/thumbnails/049/174/246/small/a-smiling-young-indian-man-with-formal-shirts-outdoors-photo.jpg";
const AVATAR2 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJp0qhEgcOaRscS93404KdEg-j5Oqk8o36LQ&s";
const AVATAR3 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFSaLz693rDjzK_V-nGa-tI7a9nMkKqyUt7g&s";

const StarIcon = () => (
  <svg viewBox="0 0 20 20" fill="#FF6B35" className="w-4 h-4 inline-block">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" className="w-5 h-5 inline-block mr-2 flex-shrink-0">
    <circle cx="10" cy="10" r="10" fill="#FF6B35" />
    <path d="M6 10l3 3 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TeacherIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7" stroke="white" strokeWidth="1.5">
    <path d="M12 12c2.7 0 5-2.3 5-5S14.7 2 12 2 7 4.3 7 7s2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 10l1.5 1.5L22 8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PaletteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7" stroke="white" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="8.5" cy="10" r="1.5" fill="white"/>
    <circle cx="15.5" cy="10" r="1.5" fill="white"/>
    <path d="M12 16c-2 0-3.5-.8-4.5-2" strokeLinecap="round"/>
  </svg>
);

export default function AboutSection() {
  return (
    <section className="w-full bg-white py-10 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 items-center">

        {/* LEFT: Images block */}
        <div className="w-full md:w-1/2 relative flex flex-col items-center">
          {/* Mobile: stack vertically, Desktop: overlap layout */}
          <div className="relative w-full">
            {/* Main classroom image */}
            <div className="w-full md:w-[90%] rounded-2xl overflow-hidden shadow-lg">
              <img src={IMG_CLASSROOM} alt="Kids in classroom" className="w-full h-56 md:h-80 object-cover" />
            </div>

            {/* Orange review card - top left on desktop, below main image on mobile */}
            <div className="hidden md:block absolute top-4 left-0 bg-[#FF6B35] rounded-2xl p-4 z-10 shadow-xl w-44">
              <div className="flex -space-x-2 mb-2">
                <img src={AVATAR1} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
                <img src={AVATAR2} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
                <img src={AVATAR3} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
              </div>
              <div className="flex gap-0.5 mb-1">
                {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
              </div>
              <p className="text-white text-sm font-semibold">4.9 / 5 kinds</p>
              <p className="text-white text-xs">Reviews</p>
            </div>

            {/* Five star rotated text - desktop only */}
            <div className="hidden md:flex absolute left-[-28px] top-1/2 -translate-y-1/2 items-center">
              <span
                className="text-[10px] font-bold text-gray-400 tracking-widest uppercase"
                style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
              >
                5200+ FIVE STAR REVIEWS
              </span>
            </div>

            {/* Girl image - bottom right on desktop */}
            <div className="hidden md:block absolute bottom-0 right-[-20px] w-52 rounded-2xl overflow-hidden shadow-xl border-4 border-white z-10">
              <img src={IMG_GIRL} alt="Girl learning" className="w-full h-52 object-cover" />
            </div>
          </div>

          {/* Mobile: orange card */}
          <div className="md:hidden mt-4 bg-[#FF6B35] rounded-2xl p-4 w-full">
            <div className="flex -space-x-2 mb-2">
              <img src={AVATAR1} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
              <img src={AVATAR2} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
              <img src={AVATAR3} className="w-8 h-8 rounded-full border-2 border-white object-cover" />
            </div>
            <div className="flex gap-0.5 mb-1">
              {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
            </div>
            <p className="text-white text-sm font-semibold">4.9 / 5 Reviews</p>
          </div>

          {/* Mobile: five star reviews text */}
          <p className="md:hidden text-center text-xs font-bold text-gray-400 tracking-widest uppercase mt-3">
            5200+ FIVE STAR REVIEWS
          </p>

          {/* Mobile: girl image */}
          <div className="md:hidden mt-4 w-full rounded-2xl overflow-hidden shadow-lg">
            <img src={IMG_GIRL} alt="Girl learning" className="w-full h-64 object-cover" />
          </div>
        </div>

        {/* RIGHT: Content */}
        <div className="w-full md:w-1/2 md:pl-8 lg:pl-16">
          {/* Label */}
          <div className="inline-flex items-center gap-2 border border-gray-200 rounded-full px-4 py-1 text-sm font-medium text-gray-700 mb-4">
            <span className="text-[#FF6B35] font-bold text-lg leading-none">✦</span>
            About Us
          </div>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0D1B2A] leading-tight mb-4">
            Nurturing young learners with care and creativity
          </h2>

          {/* Subtext */}
          <p className="text-gray-500 text-sm md:text-base mb-8 leading-relaxed">
            We provide an inspiring space where children discover new skills, build confidence, and enjoy learning through hands-on activities.
          </p>

          {/* Feature cards row */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-full bg-[#1B4D6E] flex items-center justify-center flex-shrink-0">
                <TeacherIcon />
              </div>
              <div>
                <p className="font-bold text-[#0D1B2A] text-sm md:text-base">Experienced & Caring Teachers</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-full bg-[#1B4D6E] flex items-center justify-center flex-shrink-0">
                <PaletteIcon />
              </div>
              <div>
                <p className="font-bold text-[#0D1B2A] text-sm md:text-base">Strong Parent-Teacher Communication</p>
              </div>
            </div>
          </div>

          {/* Checklist */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-8">
            {[
              "Child centered learning approach",
              "Focus on creativity & imagination",
              "Experienced early education teacher",
              "Clean, safe & joyful environment",
            ].map((item) => (
              <div key={item} className="flex items-center text-gray-600 text-sm">
                <CheckIcon />
                {item}
              </div>
            ))}
          </div>

          {/* CTA row */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
            onClick={() => window.location.href = "/about"}
            className="bg-[#FF6B35] text-white font-bold px-6 py-3 rounded-full flex items-center gap-2 hover:bg-[#e55a24] transition-colors text-sm md:text-base">
              Know More About Us
              <span className="bg-white text-[#FF6B35] rounded-full w-6 h-6 flex items-center justify-center text-xs">→</span>
            </button>
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                <img src={AVATAR1} className="w-9 h-9 rounded-full border-2 border-white object-cover" />
                <img src={AVATAR2} className="w-9 h-9 rounded-full border-2 border-white object-cover" />
                <img src={AVATAR3} className="w-9 h-9 rounded-full border-2 border-white object-cover" />
              </div>
              <div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
                </div>
                <p className="text-xs text-gray-500 mt-0.5">4.9 / 5 Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}